import { mathFloor, mathRandom, mathCeil, mathMin, mathMax } from './internals/native.js';
import toFinite from './toFinite.js';

function randomInt(lower, upper) {
    if (lower === void 0) { lower = 0; }
    if (upper === void 0) { upper = 1; }
    lower = toFinite(lower);
    upper = toFinite(upper);
    var min = mathCeil(mathMin(lower, upper) || 0);
    var max = mathFloor(mathMax(lower, upper) || 0);
    if (min > max) {
        var temp = min;
        min = max;
        max = temp;
    }
    return mathFloor(min + mathRandom() * (max - min + 1));
}

export { randomInt as default };
